import React, {useContext} from 'react'
import Reviews from './Reviews'
import { ReviewContext } from './ReviewContext';

export default function ReviewSection() {
  
    const { reviews } = useContext(ReviewContext);
  return (
    <>
    {
      !!reviews && Array.isArray(reviews) && reviews.length > 0 ? (
      <Reviews/>
    ):<div></div>
  }
  </>
    
  )
}
